import ApplicationSettings from '../services/ApplicationSettings';

const GetAnalyticsConfig = () => {
  const analyticsConfig = {
    google: {
      id: ApplicationSettings.getApplicationSetting('googleAnalyticsTrackingId'),
    },
  };
  return analyticsConfig;
};
export default GetAnalyticsConfig;
